import copyObject from './_copyObject.js';
import getSymbolsIn from './_getSymbolsIn.js';

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

export default copySymbolsIn;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_copySymbolsIn.js
// module id = 1210
// module chunks = 0